if (window.propelDistUrl) {
	// eslint-disable-next-line no-undef, camelcase
	__webpack_public_path__ = window.propelDistUrl;
}
